module.exports = __webpack_public_path__ + "gamifyeu.png?f46628b91cea565c03c681ae3992ee24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gamifyeu.png
// module id = 55
// module chunks = 0